import React from 'react';

function ProjectRight({data}) {
    return (
        <div className="projectRight" data-aos="fade-left" data-aos-delay="300">
            <div className="projectRight__description">
                <span className="projectRight__description__name">{data.name}</span>
                <span className="projectRight__description__text">{data.text}</span>
            </div>
            <div className="projectRight__img">
                <img src={data.imageURL} alt="Project" />
            </div>
        </div>
    )
}

export default ProjectRight
